if ( typeof VideoPopup !== 'function' ) {

  class VideoPopup extends HTMLElement {

    constructor(){
      super();

      const link = this.querySelector('[data-js-video-popup-link]');
      if (!link) return;

      // Auto-trigger on load if visible
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this._triggerInline();
            observer.unobserve(this);
          }
        });
      }, { threshold: 0.1 });
      observer.observe(this);

      // Also trigger on click
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this._triggerInline();
      });
    }

    _triggerInline() {
      if (this.dataset.playing) return;
      this.dataset.playing = 'true';

      const template = this.querySelector('template');
      const container = this.querySelector('[data-js-video-popup-container]');
      if (!template || !container) return;

      const clone = template.content.firstElementChild.cloneNode(true);

      if (clone.tagName === 'VIDEO') {
        clone.muted = true;
        clone.loop = true;
        clone.autoplay = true;
        clone.playsInline = true;
        clone.setAttribute('playsinline', '');
        clone.removeAttribute('controls');
        clone.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;background:#fafaf8;opacity:0;transition:opacity 0.6s ease;';
        container.innerHTML = '';
        container.appendChild(clone);
        setTimeout(function() { clone.style.opacity = '1'; }, 50);
var playPromise = clone.play();
if (playPromise !== undefined) {
  playPromise.catch(() => {
    // Mobile blocked autoplay — play on first touch
    document.addEventListener('touchstart', function tryPlay() {
      clone.play().catch(() => {});
      document.removeEventListener('touchstart', tryPlay);
    }, { once: true });
  });
}

      }
    }

    _playMedia(media) {
      if (media && media.querySelector('video')) {
        const v = media.querySelector('video');
        v.muted = true;
        v.loop = true;
        v.play().catch(() => {});
      }
    }
  }

  if ( typeof customElements.get('video-popup') == 'undefined' ) {
    customElements.define('video-popup', VideoPopup);
  }

}
